import {getMaterialUrl} from "../modules/url";

import {ImageFromPlaylistProp} from "./data";


export function reorderImageUrls(data: ImageFromPlaylistProp[], startImageRef: number): any[] {
  const originalStartItem = data.find((item) => item.imageRef === startImageRef);
  if (!originalStartItem || originalStartItem.bookPage === null) {
    throw new Error(`ImageRef ${startImageRef} not found in data or has no bookPage.`);
  }

  let adjustedStartImageRef = startImageRef;

  if (originalStartItem.bookPage % 2 !== 0) {
    const evenPage = originalStartItem.bookPage - 1;
    const evenItem = data.find((item) => item.bookPage === evenPage);
    if (evenItem) {
      adjustedStartImageRef = evenItem.imageRef;
    }
  }

  const startItem = data.find((item) => item.imageRef === adjustedStartImageRef);
  if (!startItem) {
    throw new Error(`Adjusted ImageRef ${adjustedStartImageRef} not found in data.`);
  }

  const sortedData = [...data].sort((a, b) => a.idSort - b.idSort);
  const startIndex = sortedData.findIndex((item) => item.imageRef === adjustedStartImageRef);
  const reorderedData = [
    ...sortedData.slice(startIndex),
    ...sortedData.slice(0, startIndex),
  ];

  const seenBookPages = new Set<number>();
  const result: any[] = [];

  for (const item of reorderedData) {
    const page = item.bookPage;
    if (page === null) continue;

    const evenPage = page % 2 === 0 ? page : page - 1;
    if (seenBookPages.has(evenPage)) continue;

    const evenItems = data.filter((d) => d.bookPage === evenPage);
    const oddItems = data.filter((d) => d.bookPage === evenPage + 1);

    const combinedItems = [...evenItems, ...oddItems];
    if (!combinedItems) continue;

    const normalizeFrames = (frame?: number[][] | number[][][]): number[][][] => {
      if (!frame || frame.length === 0) return [];

      if (Array.isArray(frame[0]) && Array.isArray((frame[0] as any)[0])) {
        return frame as number[][][];
      }

      const points = frame as number[][];
      const polygons: number[][][] = [];
      let current: number[][] = [];

      for (let i = 0; i < points.length; i++) {
        const point = points[i];
        if (!point) continue;

        current.push(point);
        const first = current[0];
        const last = point;

        if (current.length > 2 && first && last && first[0] === last[0] && first[1] === last[1]) {
          polygons.push(current);
          current = [];
        }
      }

      if (current.length > 0) {
        polygons.push(current);
      }

      return polygons;
    };

    const evenFrames = evenItems.flatMap(item => normalizeFrames(item.spreadFrame));
    const oddFrames = oddItems.flatMap(item => normalizeFrames(item.spreadFrame));
    const combinedSpreadFrames = [...evenFrames, ...oddFrames];

    const evenImageRefs = evenItems.map(item => item.imageRef);
    const oddImageRefs = oddItems.map(item => item.imageRef);
    const combinedImageRefs = [...evenImageRefs, ...oddImageRefs];

    seenBookPages.add(evenPage);
    if (combinedItems.length === 0) continue;

    result.push({
      url: `${getMaterialUrl()}/img/spreads/ddz_spread_${combinedItems[0] ? combinedItems[0].imageRef : 1}.jpg`,
      spreadFrame: combinedSpreadFrames,
      id: combinedItems[0] ? combinedItems[0].imageRef : 1,
      imageRefs: combinedImageRefs,
      has_geom_frame: combinedItems[0] ? combinedItems[0].has_geom_frame : false,
    });
  }

  return result;
}
